module.exports = __webpack_public_path__ + "img/doc.8b9bffdd.png";